<template>
  <div class="container">
      <div v-if="$store.state.common.theme!=3" class="navbar">
            <div
            :class="['navbar_list',activeTab==index ? 'cur' :'']"
            v-for="(item,index) of tabs"
            :key="index"
            @click="tabClick(index)"
            >
                <span>{{item}}</span>
                <i></i>
            </div>
      </div>
      <div v-if="$store.state.common.theme==3" class="navbar_theme_3">
        <div
        :class="['navbar_list',activeTab==index ? 'cur' :'']"
        v-for="(item,index) of tabs"
        :key="index"
        @click="tabClick(index)"
        >
            <span>{{item}}</span>
            <i></i>
        </div>
  </div>
      <!-- 搜索框 -->
      <section class="search_box" v-if="activeTab==1">
        <section class="search_box_inpt">
          <img class="search_icon" src="../../assets/images/search.png" />
          <input ref="search_inp"
            type="text"
            placeholder="请输入姓名或手机号搜索"
            v-model="key"
            @input="inputFun"
            maxlength="20"
          />
          <img
            class="clear_img"
            @click.stop="searchClear"
            v-if="key.length"
            src="../../assets/images/btn_clear.png"
          />
        </section>
        <span class="search_btn" v-if="key.length" @click="cancelSearch">取消</span>
      </section>

      <div class="shop_list"  v-if="approvalArr.length>0">
            <scroll  :allLoaded="allLoaded"
                :data="approvalArr"
                @pulldown="loadData"
                @loadUp="loadup" >
                <div :class="['list_box' ,item.tenType != 2?'list_box1':'']" @click="goDetail(item)"
                    v-for="(item,index) in approvalArr" :key="index">
                    <img v-if="item.tenType !=2" class="item_image1" :src="require(`../../assets/images/approve/icon_approve_company_${common.theme}.png`)"/>
                    <img v-else class="item_image" src="../../assets/images/icon_approve_visitor.png"/>
                    <div class="item_div">
                        <div class="item_div_top">
                            <span class="item_div_span1" v-if="item.tenType != 2">企业认证</span>
                            <span class="item_div_span1" v-else>访客预约</span>
                            <span class="item_div_span2">{{item.createTime | formatTime}}</span>
                        </div>
                        <div  v-if="item.tenType != 2" class="item_div_center">
                           <span class="item_div_center_span">{{item.userName}}</span>
                           <div class="item_div_center_line"></div>
                           <span class="item_div_center_span">{{item.phone}}</span>
                        </div>
                        <span v-else class="item_div_bottom">{{item.visitorUserName}} - {{item.visitorCompany}}</span>
                        <span v-if="item.tenType != 2" class="item_div_bottom">{{item.company}}</span>
                    </div>

                    <img v-if="item.tenType != 2 && item.status ==1" class="item_type_img" src="../../assets/images/icon_audit_passed.png"/>
                    <img v-if="item.tenType == 2 && item.examineStatus ==2" class="item_type_img" src="../../assets/images/icon_audit_passed.png"/>
                    <img v-if="item.tenType != 2 && item.status ==2" class="item_type_img" src="../../assets/images/icon_audit_failed.png"/>
                    <img v-if="item.tenType == 2 && item.examineStatus ==3" class="item_type_img" src="../../assets/images/icon_audit_failed.png"/>
                </div>
            </scroll>
        </div>
        <div class="noMess" v-if="approvalArr.length==0 && loaded">
          <no-message></no-message>
        </div>
          <!-- <div class="nodata" v-if="approvalArr.length==0 && loaded">
              <img class="nodataImage" src="../../assets/images/img_blankpage.png">
              <span class="nodataSpan">暂无数据～</span>
          </div> -->

 </div>
</template>
<script>

import Scroll from "../../components/scroll";
import NoMessage from "../../components/nomessage";
import { mapState } from 'vuex';
import { getUserTenantList } from "../../utils/api";
import util from '../../utils/util';
let timer = "";

export default {
  name: "approvalList",
  components: {
     Scroll,
     NoMessage
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },

  filters: {

    formatTime(val){
      return util.formatTime(new Date(val),10)
      //configObj.formatTime(new Date(val),'-','yyyymmdd');
    }
  },

  data() {
    return {
        tabs: ['待审批','已审批'],
        allLoaded:false,
        loaded:false,
        isLoding:false,
        activeTab: 0,
        pageNo:1,
        approvalArr:[],
        key:'',
        searchEnd:"",
    }
  },

  created() {

  },
  activated () {
    this.pageNo =1;
    this.allLoaded =false;
    this.getUserTenantListAction();
    //this.getParkInfo();
    // if (this.parkId !== this.$route.params.id) {
    //   this.parkId = this.$route.params.id;
    //   this.getParkMemberAction();
    // }
  },
  methods: {
    getUserTenantListAction(){
         this.isLoding =true;
         let params = {
            marketId:  this.common.marketInfo.id,
            userId: this.common.userId,
            "status": this.activeTab,
            "pageNo": this.pageNo,
            "pageSize": 10
         }
         if(this.key){
           params.keyword=this.key;
         }
        getUserTenantList(params).then(res => {
            this.isLoding=false;
            this.loaded =true;
            if (res.res.code === 10000 && res.body) {
               // console.log(res)
                if(this.pageNo==1){
                    this.approvalArr = res.body.userTenantList;
                } else if(res.body.userTenantList.length>0){

                    this.approvalArr = this.approvalArr.concat(res.body.userTenantList);
                }
                if(res.body.userTenantList.length != 10){
                    this.allLoaded =true;
                }
            }
        });

    },

    tabClick (val) {
      this.activeTab = val;
      this.searchClear();
      this.pageNo = 1;
      this.allLoaded =false;
      this.isLoding =false;
      this.getUserTenantListAction();
    },

        //下拉刷新
     loadData(){
       console.log("in loadData");
       if(this.isLoding){
         return;
       }
       this.pageNo=1;
       this.allLoaded =false;
       this.getUserTenantListAction();
     },

     //上拉
     loadup(){
       console.log("in loadup");
       if(this.isLoding){
         return;
       }
       if(this.allLoaded==true){
         return;
       }
       this.pageNo=this.pageNo+1;
       this.getUserTenantListAction();
     },
     goDetail(item){
         if(item.tenType != 2){
              var url ='/approvalDetail?id=' + item.id ;
              //+ '&createTime=' + item.createTime + '&userName=' + encodeURI(item.userName) + '&phone=' + item.phone + '&email=' + item.email + '&company=' + encodeURI(item.company) +
             //'&status=' + item.status + '&photoPath=' + item.photoPath + '&approvalUser='+encodeURI(item.approvalUser) +'&marketName='+encodeURI(item.marketName);

            //  if (item.department) {
            //     url = url + '&department=' + encodeURI(item.department)
            //  }
             this.$router.push({path:url});
         }else{
            this.$router.push(`/VisitorReservationDetail/${item.id}`);
         }
     },
    cancelSearch() {
      //this.$router.go(-1);
      this.searchClear();
      this.$refs.search_inp.blur();
    },
    // 点击清空图标
    searchClear() {
      this.key = "";
      this.searchEnd = 0;
      //this.dataList = [];
    },
    inputFun() {
      //键盘输入时触发input事件
      clearTimeout(timer);
      var that = this;
     // that.dataList = [];
      if (that.key.length === 0 && that.key.length === 0) {
        //如果输入框为空
        that.searchEnd = 0;
      } else {
        this.searchEnd = 2;
        timer = setTimeout(function() {
          that.loadData();
        }, 1000);
      }
    },
  }

}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: #EEEEEE;
  .flex(column);
  .shop_list {
    flex: 1;
    height: 500px;
  }
}

.navbar {
  .flex();
  justify-content: center;
  width: 100%;
  height: 94px;
  margin: 0 auto;
  background: #EEEEEE;
  .navbar_list {
    .flex(column);
    text-align: center;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding: 24px 0 12px;
    span {
      height: 42px;
      line-height: 42px;
      color: @color9;
    }
    i {
      width: 32px;
      height: 6px;
      background: #EEEEEE;
    }
    &.cur {
      span {
        color: @color17;
        font-weight:bold;
      }
      i{
        background: @color17;
      }
    }
  }
}

.navbar_theme_3 {
  .flex();
  justify-content: center;
  width: 100%;
  height: 94px;
  margin: 0 auto;
  background: #EEEEEE;
  .navbar_list {
    .flex(column);
    text-align: center;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding: 24px 0 12px;
    span {
      height: 42px;
      line-height: 42px;
      color: @color9;
    }
    i {
      width: 200px;
      height: 6px;
      background: #EEEEEE;
    }
    &.cur {
      span {
        color: #9A8162;

        font-weight:bold;
      }
      i{
        background: #9A8162;
      }
    }
  }
}


  .tab-panels {
    position: relative;
    width: 1500px;
    flex-direction: row;
    display: flex;
    /* background-color: #F5F5F5; */
    transition: left 0.2s ease-in-out;
  }

  .serachDiv{
    width: 100%;
    height: 120px;
    display: flex;
    .serach_bg{
      display: flex;
      flex-direction: row;
      margin-left: 20px;
      margin-top: 26px;
      width:710px;
      height:68px;
      background:rgba(248,248,248,1);
      border-radius:8px;
    }
  }

  .list_box{
      position: relative;
      margin-top: 20px;
      margin-left: 20px;
      width:710px;
      background-color: #ffffff;
      display: flex;
      flex-direction: row;
      height: 144px;
  }
  .list_box1{
    height: 188px;
  }
  .noMess{
    margin-top:300px;
  }
  .item_type_img{
      right: 28px;
      top: 20px;
      position: absolute;
      width: 100px;
      height: 100px;
      display: flex;

  }


.item_image{
    width: 44px;
    height: 44px;
    margin-top: 50px;
    margin-left: 40px;

}
.item_image1{
    width: 44px;
    height: 44px;
    margin-top: 72px;
    margin-left: 40px;

}
.item_div{
    flex-direction: column;
    margin-left: 40px;
    width: 100%;
    display: flex;
}

.item_div_top{
    margin-top: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.item_div_span1{
    height:40px;
    font-size:28px;
    color:rgba(51,51,51,1);
    line-height:40px;
}


.item_div_span2{
    margin-right: 28px;
    height:34px;
    font-size:24px;
    color:rgba(153,153,153,1);
    line-height:34px;

}
.item_div_center{
   flex-direction: row;
   display: flex;
   .item_div_center_line{
      margin-top: 18px;
      margin-left: 20px;
      margin-right: 20px;
      width:2px;
      height:24px;
      background:rgba(234,234,234,1);

   }
   .item_div_center_span{
      margin-top: 14px;
      height:34px;
      font-size:24px;
      color:rgba(153,153,153,1);
      line-height:34px;
      max-lines: 1;
      max-width:558px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

   }
}
.item_div_bottom{
    margin-top: 14px;
    height:34px;
    width:100%;
    font-size:24px;
    color:rgba(153,153,153,1);
    line-height:34px;
    max-lines: 1;
    max-width:558px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.nodata{
    margin-top: 324px;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   display: flex;
}
.nodataImage{
    width: 160px;
    height: 160px;
    display: flex;
}

.nodataSpan{
    margin-top: 28px;
    font-size:.32rem;
    line-height: .4rem;
    color: #999;
}

.search_box {
  display: flex;
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // height: 68px;
  width: 100%;
  height: 120px;
  .flex();
  align-items: center;
  // background:#fff;
  // z-index:2;
  .search_btn {
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
    display: block;
    padding: 0 32px 0 40px;
  }
  .search_box_inpt {
    flex: 1;
    height: 68px;
    margin-left: 20px;
    margin-right: 20px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    position: relative;
    .flex();
    align-items: center;
    .search_icon {
      width: 44px;
      height: 44px;
      display: block;
      margin: 0 14px;
    }
    input {
      flex: 1;
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      background: transparent;
      height: 68px;
    }
    .clear_img {
      position: absolute;
      width: 44px;
      height: 44px;
      padding: 12px;
      top: 0;
      right: 0;
    }
  }
}


</style>